import { render, staticRenderFns } from "./ContributionScreen.vue?vue&type=template&id=0099f6fa&"
import script from "./ContributionScreen.vue?vue&type=script&lang=js&"
export * from "./ContributionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports